<template>
    <div class="toster-wrap error-tost">
        <div class="toster-icon" >
            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M31 15.5C31 24.0604 24.0604 31 15.5 31C6.93959 31 0 24.0604 0 15.5C0 6.93959 6.93959 0 15.5 0C24.0604 0 31 6.93959 31 15.5ZM11.7998 8.33699L8.00012 12.1513L11.5308 15.6684L8 19.1857L11.7997 23L15.3451 19.4682L18.8905 23L22.6902 19.1857L19.1594 15.6684L22.6901 12.1513L18.8904 8.33699L15.3451 11.8687L11.7998 8.33699Z" fill="white"/>
            </svg>
        </div>
        <div class="toster-content">{{ capitalizeMessage(message) }}</div>
    </div>
</template>
<script>
export default {
    name: "ErrorModal",
    props: ['message'],
    methods:{
        capitalizeMessage(msg){
            if(typeof msg == 'string'){
                msg = msg.trim();
                return msg.charAt(0).toUpperCase() + msg.slice(1).toLowerCase();
            }else
                return msg
            
        }
    }
}
</script>